import CryptoJS from 'crypto-js';

const encrypt = (plainText) => {

    const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_API_KEY_CRYPTO_KEY)
    const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_API_KEY_CRYPTO_IV)

    if (!key || !iv) {
        console.warn('Crypto environment variables not set, key: ' + key + ', iv: ' + iv);
        throw new Error("Crypto environment variables not set");
    }

    const encrypted = CryptoJS.AES.encrypt(plainText, key, { iv: iv });
    return encrypted.toString().replace(/\+/g, '.').replace(/\//g, '_').replace(/=/g, '-');
}

export default encrypt